import React from 'react'
import styled from '@emotion/styled'
import { Typography, TypographyProps } from '@mui/material'
import { typography } from '../../tokens/typography'

const birdsongVariants = ['h1', 'h2', 'h3', 'p1', 'p2', 'p3']
type BSTextProps = {
  variant?: 'h1' | 'h2' | 'h3' | 'p1' | 'p2' | 'p3'
  children: React.ReactNode
}

const BSText = ({ variant = 'p1', children }: BSTextProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  let Element
  switch (variant) {
    case 'h1':
      Element = styled.h1`
        ${typography.up5.regularSans}
        margin: 0;
      `
      break
    case 'h2':
      Element = styled.h2`
        ${typography.up4.regularSans}
        margin: 0;
      `
      break
    case 'h3':
      Element = styled.h3`
        ${typography.up3.regularSans}
        margin: 0;
      `
      break
    case 'p1':
      Element = styled.p`
        ${typography.baseline.regularSans}
        margin: 0;
      `
      break
    case 'p2':
      Element = styled.p`
        ${typography.down1.regularSans}
        margin: 0;
      `
      break
    case 'p3':
      Element = styled.p`
        ${typography.down2.regularSans}
        margin: 0;
      `
      break
    default:
      Element = styled.p`
        ${typography.baseline.regularSans}
        margin: 0;
      `
  }

  return <Element>{children}</Element>
}

export type TextProps = BSTextProps | TypographyProps
export const Text = (props: TextProps) => {
  const { variant } = props

  if (
    !variant ||
    // For overlapping variants (h1, h2, h3), prefer BS unless
    // using the MUI-only property component
    (birdsongVariants.includes(variant) && !('component' in props))
  ) {
    return <BSText {...(props as BSTextProps)} />
  }

  return <Typography {...(props as TypographyProps)} />
}
